import request from '../utils/request';

const BASE_URL = '/goods-order';

export const orderApi = {
  // 分页查询订单
  pageOrders: (page = 1, pageSize = 10, queryParams = {}) => {
    return request.post(`${BASE_URL}/page`, 
      {page, pageSize, ...queryParams}
    );
  },

  // 创建订单
  createOrder: (orderData) => {
    return request.post(BASE_URL, orderData);
  },

  // 获取订单详情
  getOrderDetail: (orderId) => {
    return request.get(`${BASE_URL}/${orderId}`);
  },

  // 更新订单
  updateOrder: (orderId, orderData) => {
    return request.put(`${BASE_URL}/${orderId}`, orderData);
  },

  // 删除订单
  deleteOrder: (orderId) => {
    return request.delete(`${BASE_URL}/${orderId}`);
  },

  // 查看订单的平台收货记录
  getPlatformReceiveRecords: (orderId) => {
    return request.get(`${BASE_URL}/platform/receive-records/${orderId}`);
  },

  // 查看订单的快检费记录
  getPlatformFeeOrder: (orderId) => {
    return request.get(`${BASE_URL}/platform/fee-orders/${orderId}`);
  }
}; 